import {
    CreateJobGraphData,
    FabricOverviewGenerateOutput,
    fabricOverviewGenerateTask,
    FabricOverviewGenerateTemplateType,
    fabricOverviewPostRenderStepTask,
    JobNodes,
    TileableMaterialPostRenderStepInput,
} from "@cm/job-nodes"
import {Settings} from "@common/models/settings/settings"
import {JobGraphMaterial} from "@common/models/material-assets-rendering/job-graph-material"

export function jobGraphFn_fabricOverviewGenerate(
    materialDetails: JobGraphMaterial,
    filenames: TileableMaterialPostRenderStepInput["filenames"],
    templateType: FabricOverviewGenerateTemplateType,
    tileableImageDataObjectId: string,
    fullWidthCm: number,
    repeatWidthCm?: number,
    repeatHeightCm?: number,
    railroaded?: boolean,
): CreateJobGraphData {
    const renderTask = JobNodes.task(fabricOverviewGenerateTask, {
        input: JobNodes.value({
            templateType,
            tileableImage: JobNodes.dataObjectReference(tileableImageDataObjectId),
            mediaType: "image/jpeg" as const,
            fullWidthCm,
            repeatWidthCm,
            repeatHeightCm,
            railroaded,
        }),
    })
    return postRenderTask(materialDetails, filenames, renderTask)
}

function postRenderTask(
    materialDetails: JobGraphMaterial,
    filenames: TileableMaterialPostRenderStepInput["filenames"],
    renderTask: JobNodes.TypedDataNode<FabricOverviewGenerateOutput>,
) {
    const postRenderTask = JobNodes.task(fabricOverviewPostRenderStepTask, {
        input: JobNodes.struct({
            renderImage: JobNodes.get(renderTask, "dataObject"),
            materialId: JobNodes.value(materialDetails.legacyId),
            customerId: JobNodes.value(materialDetails.organization.legacyId),
            filenames: JobNodes.value(filenames),
        }),
    })
    return JobNodes.jobGraph(postRenderTask, {
        platformVersion: Settings.APP_VERSION,
    })
}
